module.exports = __webpack_public_path__ + "img/corp_logo.dd5853e6.svg";